module.exports = __webpack_public_path__ + "static/img/Random Blood Sugar RBS.1f6cbe9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/specialities/Random Blood Sugar RBS.svg
// module id = 1EBm
// module chunks = 7